import base from './base.js'
import oddEven from './oddEven.js'
import factorization from './factorization.js'
import detectFibonacciNumber from './detectFibonacciNumber.js'
import factorial from './factorial.js'

export default{
	base: base,
	oddEven: oddEven,
	factorization: factorization,
	factorial: factorial,
	detectFibonacciNumber: detectFibonacciNumber

}



// WEBPACK FOOTER //
// ./src/assets/formulas/index.js